import { useState, useEffect, useCallback } from 'react'
import { gameApi } from '../api/endpoints'
import { GuessNumberStatus } from '../types'

export function useGames() {
  const [status, setStatus] = useState<GuessNumberStatus | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchStatus = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const res = await gameApi.getGuessNumberStatus()
      setStatus(res)
    } catch (err: any) {
      setError(err.response?.data?.message || 'خطا در بارگذاری وضعیت بازی')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchStatus()
  }, [fetchStatus])

  return { status, loading, error, refetch: fetchStatus }
}
